import { useState, useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import { message } from 'antd'

import { useParams } from 'react-router-dom'

// components

import MentionEditor from '../../../components/MentionEditor/MentionEditor'

// slices

import { loginState } from '../../login/login.slice'

import {
    mainTaskById,
    taskById,
    updateComment,
    updateMainTaskComment,
} from '../../taskRefactored/tasks.slice'
import { isTaskMutationSuccess } from '../../taskRefactored/tasks.service'

const ProjectCommentInput = ({
    taskId,
    taskListKind = 'support',
    projectId,
    onCommentAdded,

    setCommentChange,

    mentionData,

    setMentionData,

    files,

    setFiles,
}) => {
    const dispatch = useDispatch()

    const { userProfile } = useSelector(loginState)

    const { id: routeProjectId } = useParams()

    const resolvedProjectId = projectId || routeProjectId

    // Comment/Mention state

    const [clearEditor, setClearEditor] = useState(false)

    const [addCommentLoader, setAddCommentLoader] = useState(false)

    // Handle mention changes

    const handleChangeMentions = (newValue, newPlainTextValue, mentions) => {
        setMentionData({
            ...mentionData,
            value: newValue,
            comment: newPlainTextValue,
            mentionDataList: mentions,
        })
    }

    // Add comment function

    async function addComment(files) {
        setAddCommentLoader(true)

        const isMainTask = taskListKind === 'main'
        const commentPayload = {
            id: taskId,
            data: {
                fieldName: 'add',
                comment: {
                    userId: userProfile?._id,
                    username: userProfile?.userName,
                    createdDate: new Date().getTime(),
                    content: mentionData?.value || '',
                    mentionId: mentionData?.mentionDataList || [],
                    attachments: files?.length > 0 ? files : [],
                },
            },
        }

        const result = await dispatch(
            isMainTask
                ? updateMainTaskComment(commentPayload)
                : updateComment(commentPayload)
        )

        const data = result?.payload?.data

        if (data) {
            setMentionData({ ...mentionData, value: '', comment: '' })

            setFiles([])

            const { success, message: checkMessage } = data
            const isSuccess = isMainTask
                ? isTaskMutationSuccess(data)
                : Boolean(success)

            if (isSuccess) {
                setAddCommentLoader(false)

                const newComment = {
                    uId: userProfile?._id,

                    mentionId: mentionData?.mentionDataList,

                    attachments: files?.length > 0 ? files : [],

                    content: mentionData?.value,

                    createdDate: new Date().getTime(),

                    user: {
                        _id: userProfile?._id,

                        name: userProfile?.userName,
                    },

                    username: userProfile?.userName,
                }

                if (setCommentChange) {
                    setCommentChange((prev) => [
                        newComment,

                        ...(Array.isArray(prev) ? prev : []),
                    ])
                }

                await dispatch(
                    isMainTask
                        ? mainTaskById({ _id: taskId })
                        : taskById({ _id: taskId })
                )

                if (onCommentAdded) {
                    onCommentAdded()
                }
            } else {
                if (checkMessage) {
                    message.error(checkMessage)

                    setAddCommentLoader(false)
                } else {
                    message.error('Something went wrong, try again later.')

                    setAddCommentLoader(false)
                }
            }
        }
    }

    // Submit comment with attachments (files are already uploaded URLs)

    async function s3Upload() {
        setAddCommentLoader(true)

        // Files are already uploaded URLs from MentionEditor

        const attachmentUrls = Array.isArray(files) ? files : []

        await addComment(attachmentUrls)

        setClearEditor(true)
    }

    useEffect(() => {
        if (clearEditor) {
            setClearEditor(false)
        }
    }, [clearEditor])

    return (
        <MentionEditor
            projectId={resolvedProjectId}
            excludeUserIds={mentionData?.mentionDataList || []}
            handleChangeMentions={handleChangeMentions}
            value={mentionData?.value}
            clearTrigger={clearEditor}
            loadingButton={addCommentLoader}
            onClickComment={() => s3Upload()}
            disabledButton={
                !mentionData?.comment?.trim() && !(files?.length > 0)
            }
            showInsertMenu
            getFileList={(files) => {
                setFiles(files)
            }}
        />
    )
}

export default ProjectCommentInput
